export default __webpack_public_path__ + "static/RootSans-9Bold-8c0adaf9d0a2e270d4f8187bf93fbe35.woff";